// services/grid-export.service.ts
import { Injectable } from '@angular/core';
import { GridApi } from 'ag-grid-community';

export interface ExportOptions {
  fileName: string;
  columnKeys?: string[];
  onlySelected?: boolean;
  allColumns?: boolean;
  skipHeader?: boolean;
  processCellCallback?: (params: any) => any;
  processHeaderCallback?: (params: any) => any;
  appendDateToFileName?: boolean;
  customTimestamp?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GridExportService {
  
  constructor() {}
  
  /**
   * Export grid data to CSV
   * @param gridApi The AG Grid API instance
   * @param options Export configuration options
   * @returns boolean indicating success/failure
   */
  exportToCsv(gridApi: GridApi, options: ExportOptions): boolean {
    if (!gridApi) {
      console.error('Grid API is not available');
      return false;
    }
    
    // Generate filename with date if requested
    let fileName = options.fileName || 'export';
    if (options.appendDateToFileName !== false) {
      const timestamp = options.customTimestamp || 
        new Date().toISOString().slice(0, 19).replace(/:/g, '-').replace('T', '_');
      fileName = `${fileName}_${timestamp}.csv`;
    } else if (!fileName.endsWith('.csv')) {
      fileName = `${fileName}.csv`;
    }
    
    // Configure export parameters
    const params = {
      fileName,
      suppressQuotes: false,
      columnSeparator: ',',
      columnKeys: options.columnKeys || [],
      skipHeader: options.skipHeader || false,
      allColumns: options.allColumns || false,
      onlySelected: options.onlySelected || false,
      processCellCallback: options.processCellCallback,
      processHeaderCallback: options.processHeaderCallback
    };
    
    try {
      gridApi.exportDataAsCsv(params);
      return true;
    } catch (error) {
      console.error('Failed to export grid data:', error);
      return false;
    }
  }
  
  /**
   * Export data from multiple grids
   * @param gridExports Array of grid APIs and their export options
   * @returns Array of success/failure results
   */
  exportMultipleGrids(gridExports: { gridApi: GridApi, options: ExportOptions }[]): boolean[] {
    return gridExports.map(item => this.exportToCsv(item.gridApi, item.options));
  }
}